import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
    selector: 'app-credits-transfer-failure',
    templateUrl: './credits-transfer-failure.component.html',
    styleUrls: ['./credits-transfer-failure.component.scss'],
    standalone: false
})
export class CreditsTransferFailureComponent implements OnInit {
  @Output() togglePopUp: EventEmitter<any> = new EventEmitter();
  @Output() tryAgainHandler: EventEmitter<any> = new EventEmitter();
  @Input() requestType!: string;

  constructor() {}

  ngOnInit() {
    document.getElementById('overlay')!.style.display = 'block';
  }

  closePopup(): void {
    this.togglePopUp.emit();
  }
}
